import * as React from 'react';

export interface IAreasListProps {
    items: Area[];
    header: string;
}

class Area {
    public title: string;
    public url: string;
}

export class AreasList extends React.Component<IAreasListProps> {
    constructor(props: IAreasListProps) {
        super(props);
    }

    public render(): JSX.Element {
        const header = this.props.header === null || this.props.header === '' ? 'Områden' : this.props.header;

        return (
            <div className="block block--shadow">
                <h2 className="h5 yellow-border-bottom">{header}</h2>
                {this.props.items.map(this.renderItem.bind(this))}
            </div>
        );
    }

    private renderItem(area: Area, index: number): JSX.Element {
        return (
            <div className="landing-page-link" key={index}>
                <i className="icon-angle-up icon-rotate-90"></i>
                <a href={area.url} dangerouslySetInnerHTML={{ __html: area.title.replace('/', ' / ') }}></a>
            </div>
        );
    }
}
